import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { DocumentDownload } from "iconsax-react";

const KitComunicazione = () => {

    const downloadFile = (fileName) => {
        // Crea il percorso del file nella cartella public/downloads
        const fileUrl = `/downloads/${fileName}`;
        
        // Crea un elemento anchor temporaneo per il download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const files = [
        {
            name: "LocandinaA3.pdf",
            title: "Locandina A3",
            description: "Locandina promozionale in formato A3 per promuovere SportId all'interno della tua struttura sportiva."
        },
        {
            name: "InvitoAtletiDirigenti.docx", 
            title: "Invito Atleti e Dirigenti",
            description: "Template per invitare atleti e dirigenti ad utilizzare SportId® Player"
        },
        {
            name: "InvitoMaestri.docx",
            title: "Invito Coach, Maestri e Allenatori",
            description: "Template per invitare lo staff tecnico a usare SportId® Player e SportId Coach®"
        }
    ];

    return (
        <>
            <Row>
                <Col xl={12}>
                    <Card>
                        <Card.Header>
                            <Card.Title as="h4">Kit di Comunicazione</Card.Title>
                            <Card.Text className="mb-0 subtitle">
                                Scarica i files del kit di comunicazione per la tua struttura sportiva
                            </Card.Text>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                {files.map((file, index) => (
                                    <Col xl={4} lg={6} md={6} sm={12} key={index}>
                                        <Card className="mb-4">
                                            <Card.Body className="text-center">
                                                <div className="mb-3">
                                                    <DocumentDownload 
                                                        size="48" 
                                                        color="#007bff" 
                                                        variant="Bulk"
                                                    />
                                                </div>
                                                <Card.Title as="h5" className="mb-2">
                                                    {file.title}
                                                </Card.Title>
                                                <Card.Text className="text-muted mb-3">
                                                    {file.description}
                                                </Card.Text>
                                                <Button 
                                                    variant="primary" 
                                                    size="sm"
                                                    onClick={() => downloadFile(file.name)}
                                                    className="sid-btn-compact"
                                                >
                                                    <DocumentDownload 
                                                        size="16" 
                                                        className="me-2" 
                                                    />
                                                    Scarica
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            
                            <Row className="mt-4">
                                <Col xl={12}>
                                    <Card className="bg-light">
                                        <Card.Body>
                                            <h6 className="mb-2">Informazioni sui file:</h6>
                                            <ul className="mb-0">
                                                <li>Se riscontri problemi con il download o desideri altro materiale per promuovere SportId nella tua struttura, scrivici a <a href="mailto:hello@sportid.it">hello@sportid.it</a>.</li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default KitComunicazione;